var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "Key"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.readonly || _vm.disabledKey
    },
    model: {
      value: _vm.organizationVariable.key,
      callback: function callback($$v) {
        _vm.$set(_vm.organizationVariable, "key", $$v);
      },
      expression: "organizationVariable.key"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "名稱"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "disabled": true
    },
    model: {
      value: _vm.configMapping.name,
      callback: function callback($$v) {
        _vm.$set(_vm.configMapping, "name", $$v);
      },
      expression: "configMapping.name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "required": "",
      "disabled": _vm.readonly
    },
    model: {
      value: _vm.organizationVariable.type,
      callback: function callback($$v) {
        _vm.$set(_vm.organizationVariable, "type", $$v);
      },
      expression: "organizationVariable.type"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v("請選擇")]), _c('b-form-select-option', {
    attrs: {
      "value": "string"
    }
  }, [_vm._v("string")]), _c('b-form-select-option', {
    attrs: {
      "value": "json"
    }
  }, [_vm._v("json")]), _c('b-form-select-option', {
    attrs: {
      "value": "boolean"
    }
  }, [_vm._v("boolean")]), _c('b-form-select-option', {
    attrs: {
      "value": "number"
    }
  }, [_vm._v("number")]), _c('b-form-select-option', {
    attrs: {
      "value": "file"
    }
  }, [_vm._v("file")])], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "Value"
    }
  }, [_vm.configMapping.type == 'boolean' ? _c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.readonly
    },
    model: {
      value: _vm.organizationVariable.value,
      callback: function callback($$v) {
        _vm.$set(_vm.organizationVariable, "value", $$v);
      },
      expression: "organizationVariable.value"
    }
  }) : _vm.configMapping.type == 'json' || _vm.configMapping.type == 'array' ? _c('editor', {
    attrs: {
      "disabled": _vm.readonly,
      "width": "100%",
      "height": "200px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.editValue,
      callback: function callback($$v) {
        _vm.editValue = $$v;
      },
      expression: "editValue"
    }
  }) : _vm.configMapping.type == 'number' ? _c('b-form-input', {
    attrs: {
      "disabled": _vm.readonly,
      "type": "number"
    },
    model: {
      value: _vm.organizationVariable.value,
      callback: function callback($$v) {
        _vm.$set(_vm.organizationVariable, "value", $$v);
      },
      expression: "organizationVariable.value"
    }
  }) : _vm.configMapping.type == 'file' ? _c('button', {
    staticClass: "btn btn-link px-2 text-dark align-self-start upload-button"
  }, [_c('b-form-file', {
    attrs: {
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": function change($event) {
        return _vm.upload($event);
      }
    }
  }), _c('a', {
    attrs: {
      "href": _vm.organizationVariable.value,
      "target": "_blank"
    }
  }, [_c('small', [_vm._v(" 目前路徑：" + _vm._s(_vm.organizationVariable.value || '未上傳') + " ")])])], 1) : _c('b-form-input', {
    attrs: {
      "disabled": _vm.readonly,
      "type": "text"
    },
    model: {
      value: _vm.organizationVariable.value,
      callback: function callback($$v) {
        _vm.$set(_vm.organizationVariable, "value", $$v);
      },
      expression: "organizationVariable.value"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }